import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PermissoesUsuarioGuard } from 'src/app/guards/permissoes-usuario.guard';
import { UsuarioAutenticadoGuard } from 'src/app/guards/usuario-autenticado.guard';
import { UsuarioNaoAutenticadoGuard } from 'src/app/guards/usuario-nao-autenticado.guard';
import { PermissoesUsuarioEnum } from 'src/app/domain/primecap/model/enum/permissoes-usuario.enum';
import { StringUtil } from 'src/app/utils/string.util';
import { ComissoesComponent } from './presentation/pages/comissoes/comissoes.component';
import { HomeComponent } from './presentation/pages/home/home.component';
import { InvestidoresComponent } from './presentation/pages/investidores/investidores.component';
import { PushComponent } from './presentation/pages/push/push.component';
import { RodadasComponent } from './presentation/pages/rodadas/rodadas.component';
import { PrimecapComponent } from './presentation/primecap-view/primecap-view.component';
import { AssessoresComponent } from './presentation/pages/assessores/assessores.component';
const routes: Routes = [
  {
    path: StringUtil.EMPTY,
    component: PrimecapComponent,
    children: [
      {
        path: 'ofertas',
        canActivate: [UsuarioAutenticadoGuard],
        component: HomeComponent
      },
      {
        path: 'index',
        canActivate: [UsuarioNaoAutenticadoGuard],
        loadChildren: () => import('./presentation/pages/index/index.module').then(m => m.IndexModule)
      },
      {
        path: 'dashboard',
        canActivate: [UsuarioAutenticadoGuard],
        loadChildren: () => import('./presentation/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'perfil',
        canActivate: [UsuarioAutenticadoGuard],
        loadChildren: () => import('./presentation/pages/perfil/perfil.module').then(m => m.PerfilModule)
      },
      {
        path: 'investidores',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR, PermissoesUsuarioEnum.ASSESSOR, PermissoesUsuarioEnum.ESCRITORIO]
        },
        component: InvestidoresComponent
      },
      {
        path: 'assessores',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR, PermissoesUsuarioEnum.ESCRITORIO]
        },
        component: AssessoresComponent
      },
      // {
      //   path: 'comissoes',
      //   canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
      //   data: {
      //     roles: [PermissoesUsuarioEnum.ADMINISTRADOR, PermissoesUsuarioEnum.ASSESSOR, PermissoesUsuarioEnum.ESCRITORIO]
      //   },
      //   component: ComissoesComponent
      // },
      {
        path: 'investimentos',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: []
        },
        loadChildren: () => import('./presentation/pages/dashboard/investidor/lista-investimentos/lista-investimentos.module').then(m => m.ListaInvestimentosModule)
      },
      {
        path: 'rodadas',
        canActivate: [UsuarioNaoAutenticadoGuard],
        component: RodadasComponent
      },
      {
        path: 'login',
        canActivate: [UsuarioNaoAutenticadoGuard],
        loadChildren: () => import('../../views/login/login.module').then(m => m.LoginModule)
      },
      {
        path: 'cadastrar',
        canActivate: [UsuarioNaoAutenticadoGuard],
        loadChildren: () => import('../../views/register/register.module').then(m => m.RegisterModule)
      },
      {
        path: 'usuarios',
        canActivate: [UsuarioNaoAutenticadoGuard],
        loadChildren: () => import('../../views/esqueceu-senha/esqueceu-senha.module').then(m => m.EsqueceuSenhaModule)
      },
      {
        path: 'usuarios/recuperar-senha',
        canActivate: [UsuarioNaoAutenticadoGuard],
        loadChildren: () => import('../../views/recuperar-senha/recuperar-senha.module').then(m => m.RecuperarSenhaModule)
      },
      {
        path: 'push',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ASSESSOR]
        },
        component: PushComponent
      },
      {
        path: 'detalhes',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: []
        },
        loadChildren: () => import('./presentation/pages/detalhes/detalhes.module').then(m => m.DetalhesModule)
      },
      {
        path: 'construtora',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
        },
        loadChildren: () => import('src/app/views/construtora/construtora.module').then(m => m.ConstrutoraModule)
      },
      {
        path: 'corretora',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
        },
        loadChildren: () => import('src/app/views/corretora/corretora.module').then(m => m.CorretoraModule)
      },
      {
        path: 'confirmacao-investimento',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ASSESSOR, PermissoesUsuarioEnum.INVESTIDOR]
        },
        loadChildren: () => import('src/app/domain/primecap/presentation/pages/dashboard/confirmacao-investimento/confirmacao-investimento.module').then(m => m.ConfirmacaoInvestimentoModule)
      },
      {
        path: 'empreendimento',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
        },
        loadChildren: () => import('src/app/views/empreendimento/empreendimento.module').then(m => m.EmpreendimentoModule)
      },
      {
        path: 'escritorio',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
        },
        loadChildren: () => import('src/app/views/escritorio/escritorio.module').then(m => m.EscritorioModule)
      },
      {
        path: 'administrador',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
        },
        loadChildren: () => import('src/app/domain/primecap/presentation/pages/pessoa-fisica/administrador/administrador.module').then(m => m.AdministradorModule)
      },
      {
        path: 'assessor',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
        },
        loadChildren: () => import('src/app/domain/primecap/presentation/pages/pessoa-fisica/assessor/assessor.module').then(m => m.AssessorModule)
      },
      {
        path: 'investidor',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: []
        },
        loadChildren: () => import('src/app/domain/primecap/presentation/pages/pessoa-fisica/investidor/investidor.module').then(m => m.InvestidorModule)
      },
      {
        path: 'startup',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
        },
        loadChildren: () => import('src/app/views/startup/startup.module').then(m => m.StartupModule)
      },
      {
        // path para cadastro e edição de empreendimento ou startup
        path: 'empresa/:tipoEmpresa/:idEmpresa',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
        },
        loadChildren: () => import('src/app/views/empresa/empresa.module').then(m => m.EmpresaModule)
      },
      {
        // path para cadastro e edição de rodada
        path: 'rodada/:idEmpresa/:tipoRodada/:edicao/:idRodada',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
        },
        loadChildren: () => import('src/app/views/rodada-investimento/rodada-investimento.module').then(m => m.RodadaInvestimentoModule)
      },
      {
        //PATH PARA DETALHES DA RODADA A PARTIR DA TELA DE LISTAGEM DAS EMPRESAS - ADMIN
        path: 'rodada/detalhes/:idEmpresa/:idRodada',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
        },
        loadChildren: () => import('src/app/views/rodada-investimento/rodada-investimento-detalhes/rodada-investimento-detalhes.module').then(m => m.RodadaInvestimentoDetalhesModule)
      },
      {
        //PATH PARA VISUALIZAR LISTA COM TODAS AS RODADAS ATIVAS NA PLATAFORMA - admin
        path: 'rodada/list',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
        },
        loadChildren: () => import('src/app/views/rodada-investimento/rodada-investimento-listar/rodada-investimento-listar.module').then(m => m.RodadaInvestimentoListarModule)
      },
      {
        path: 'socio',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
        },
        loadChildren: () => import('src/app/views/socio/socio.module').then(m => m.SocioModule)
      },
      {
        path: 'instituicao-financeira',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
        },
        loadChildren: () => import('src/app/views/instituicao-financeira/instituicao-financeira.module').then(m => m.InstituicaoFinanceiraModule)
      },
      {
        path: 'setor',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
        },
        loadChildren: () => import('src/app/domain/primecap/presentation/pages/setor/setor.module').then(m => m.SetorModule)
      },
      {
        path: 'momento',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
        },
        loadChildren: () => import('src/app/domain/primecap/presentation/pages/momento/momento.module').then(m => m.MomentoModule)
      },
      {
        path: 'fundo-investimento',
        canActivate: [UsuarioAutenticadoGuard, PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
        },
        loadChildren: () => import('src/app/domain/primecap/presentation/pages/fundos/fundos.module').then(m => m.FundosModule)
      },
      {
        path: 'info-primecap',
        canActivate: [PermissoesUsuarioGuard],
        data: {
          roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
        },
        loadChildren: () => import('src/app/domain/primecap/presentation/pages/cadastro-configuracoes/cadastro-configuracoes.module').then(m => m.CadastroConfiguracoesModule)
      },
      // {
      //   path: 'exemplo',
      //   canActivate: [PermissoesUsuarioGuard],
      //   data: {
      //     roles: [PermissoesUsuarioEnum.ADMINISTRADOR]
      //   },
      //   loadChildren: () => import('src/app/domain/primecap/presentation/primecap-view/exemplo/exemplo.module').then(m => m.ExemploModule)
      // },
      {
        path: '',
        redirectTo: 'index',
        pathMatch: 'full'
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrimecapRoutingModule { }
